import FormFirstStep from "./FormFirstStep";
import FormSecondStep from "./FormSecondStep";
import FormThirdStep from "./FormThirdStep";
import FormFourthStep from "./FormFourthStep";

// Define the steps array containing step component
export const formSteps = [
  { StepComponent: FormFirstStep },
  { StepComponent: FormSecondStep },
  { StepComponent: FormThirdStep },
  { StepComponent: FormFourthStep },
];
